import { Injectable } from "@angular/core";

import { dbToDate, dbToInt, dbToString } from "@dffedb/util";

import { MaalerDto } from "../model/maaler.dto";
import { Maaler } from "../model/maaler.model";

@Injectable({ providedIn: "root" })
export class MaalerMapper {
    public dtoToMaaler(ejendomNr: number, installationNr: number, dto: MaalerDto): Maaler {
        const result: Maaler = {
            ejendomNr: dbToInt(ejendomNr),
            info1: dbToString(dto.info1),
            info2: dbToString(dto.info2),
            installationNr: dbToInt(installationNr),
            maalerNr: dbToString(dto.maalerNr),
            maalerTypeNr: dbToInt(dto.typeNr),
            opsatDato: dbToDate(dto.opsatDato),
            sidsteServiceDato: dbToDate(dto.sidsteService)
        };
        return result;
    }
}
